import { IExportColumnModel } from "../../../../../shared/models";

export const ReportViewsColumnList: IExportColumnModel[] = [
]